import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LandingService } from '../landing.service';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss', '../stylesGlobLanding.scss']
})
export class PropertyDetailsComponent implements OnInit {

  page;
  domainPage: string;
  property;

  // properties:any = [];

  constructor(
    private route: ActivatedRoute,
    private _LandingService: LandingService,
    private _coreConfigService: CoreConfigService,) {

      var host = window.location.host;
        const domain = host.split('.')[1];
        let data;
        if (domain == 'ampi') {
        this.domainPage = host.split('.')[0];

        } else {
        this.domainPage = window.location.host;
        }
        // this.domainPage = 'sanluispotosi';
        console.log("este es el dominio",this.domainPage);

    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit(): void {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
    // this.domainPage = 'sanluispotosi';
    console.log("este es el dominio", this.domainPage);

    this.getInfo();
   

    document.documentElement.style.setProperty("--swiper-theme-color", "gray");
  }

  public swiperPaginations: SwiperConfigInterface = {
    pagination: true
  };


  getInfo() {
    const id = this.route.snapshot.paramMap.get('id');
    console.log('MI ID DE CASAs', id);

    this.route.queryParams.subscribe(params => {
      this. page = params['page'];
      console.log('PAGE PASS:', this.page);
      // Hacer lo que necesites con el ID de la propiedad
    });

    this.checkProperty(id);
  }


  getroperties(page) {
    return new Promise((resolve, reject) => {
        console.log('DENTRO DEL PROMISE')
        this._LandingService.getServerWithPage('getProperties', this.domainPage, Number(page)).then(
            (resp:any) => {
                console.log('RESP PROPERTIES', resp)
                resolve(resp.data);
            }, (error: any) => {
                console.log("ERROR getProperties", error);
                reject(error);
            }
        );
    });
  }


  async checkProperty(id) {
    const url = "getPropertiesRequest/" + this.domainPage;
    let consulta = localStorage.getItem('consulta');
    consulta = JSON.parse(consulta);
    
    let properties:any = await this._LandingService.postServer(url, consulta)
    properties = properties.data;
    console.log(properties,consulta);
    // let properties:any = await this.getroperties(this.page);
    this.property = properties.find(x => x.id == id);
    console.log(this.property)
    if(!this.property){
      properties = await this.getroperties(this.page -1);
      this.property = properties.find(x => x.id == id);
    }
    if(!this.property){
      properties = await this.getroperties(this.page +1);
      this.property = properties.find(x => x.id == id);
    }

    console.log('MI PROPIEDAD', this.property);
  }

  abrirLink(url){
    window.open(url, '_blank');
  }

}
